import React, { useState, useEffect } from 'react';
import { Users, Mail } from 'lucide-react';
import { supabase } from '../../services/supabase';
import { useAuth } from '../../contexts/AuthContext';
import InviteMembers from './InviteMembers';

const BusinessDashboard = ({ businessId }) => {
  const [business, setBusiness] = useState(null);
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showInviteForm, setShowInviteForm] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    if (businessId) {
      loadBusinessData();
    }
  }, [businessId]);

  const loadBusinessData = async () => {
    try {
      // Load business details
      const { data: businessData, error: businessError } = await supabase
        .from('businesses')
        .select('*')
        .eq('id', businessId)
        .single();

      if (businessError) throw businessError;
      setBusiness(businessData);

      // Load business members
      const { data: membersData, error: membersError } = await supabase
        .from('profiles')
        .select('id, email')
        .eq('business_id', businessId);

      if (membersError) throw membersError;
      setMembers(membersData);
    } catch (error) {
      console.error('Error loading business data:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="p-4">Cargando...</div>;
  }

  if (!business) {
    return <div className="p-4">Negocio no encontrado</div>;
  }

  return (
    <div className="space-y-6 p-4">
      {/* Business Info */}
      <div className="bg-white rounded-lg shadow p-6">
        <h2 className="text-2xl font-bold mb-4">{business.name}</h2>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <span className="text-gray-500">ID del Negocio</span>
            <p className="font-medium">{business.id}</p>
          </div>
          <div>
            <span className="text-gray-500">Miembros</span>
            <p className="font-medium">{members.length}</p>
          </div>
        </div>
      </div>

      {/* Members List */}
      <div className="bg-white rounded-lg shadow">
        <div className="p-4 border-b flex justify-between items-center">
          <div className="flex items-center">
            <Users className="w-5 h-5 text-gray-400 mr-2" />
            <h3 className="text-lg font-semibold">Miembros</h3>
          </div>
          <button
            onClick={() => setShowInviteForm(true)}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-700"
          >
            Invitar
          </button>
        </div>
        <div className="divide-y">
          {members.map((member) => (
            <div key={member.id} className="p-4 flex items-center">
              <Mail className="w-5 h-5 text-gray-400 mr-3" />
              <div>
                <div>{member.email}</div>
                {member.id === user.id && (
                  <span className="text-sm text-gray-500">(Tú)</span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Invite Members Modal */}
      {showInviteForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
            <InviteMembers
              businessId={businessId}
              onClose={() => setShowInviteForm(false)}
              onInviteSent={() => {
                setShowInviteForm(false);
                loadBusinessData();
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default BusinessDashboard; 